import { useState, useEffect } from 'react';
import { saveToLocalStorage, loadFromLocalStorage } from '../../functions/local';

export const LOCAL_STORAGE_AGREEMENT_KEY = 'lexdex.agreement';

function TermsPage() {
  // Initialize checkbox state from local storage
  //SSIT OLD VALUE: const [isAccepted, setIsAccepted] = useState(() => loadFromLocalStorage(LOCAL_STORAGE_AGREEMENT_KEY));
  const [isAccepted, setIsAccepted] = useState(false);

  // Use useEffect to update local storage whenever checkbox state changes
  useEffect(() => {
    saveToLocalStorage(LOCAL_STORAGE_AGREEMENT_KEY, isAccepted);
  }, [isAccepted]);
 
  return (
    <div>
      <h2 style={{ color: 'white' }}>Fast Fertig!</h2>
      <br />
      <p style={{ color: 'white' }}>
        Besten Dank für die Beantwortung aller Fragen. Bitte lesen Sie noch die folgenden Hinweise durch, bevor wir Ihre massgeschneiderte und individuelle Datenschutzerklärung für Sie erstellen.
      </p>
      <br />
      <p style={{ color: 'white' }}>
        Die Datenschutzerklärung darf nur für ein einzelnes Online-Angebot (einzelne Website inkl. dazugehöriger Social-Media-Präsenz) verwendet werden. Jede sonstige Verwendung der Datenschutzerklärung sowie die Weitergabe – ganz oder teilweise, gegen Entgelt oder gratis – ist verboten.
      </p>
      <br />
      <p style={{ color: 'white' }}>
        Haftung: Diese Datenschutzerklärung wurde anwaltlich geprüft und mehrfach durch Datenschutzrechts-Expertinnen und -Experten getestet. Trotzdem übernehmen wir für den Inhalt und die Verwendung der erstellten Datenschutz­erklärung keine Haftung. Wenn Sie eine individuelle Beratung und detaillierte Prüfung im Einzelfall wünschen, empfehlen wir Ihnen eine zusätzliche anwaltliche Beratung.
        Sollten offene Fragen zu Ihrer Datenschutzerklärung bestehen, hilft Ihnen das FAQ auf unserer Webseite weiter. Bei weitergehenden Fragen oder Anliegen, können Sie uns Sie uns via mail@lexdex.ch kontaktieren. Wir handeln  nach bestem Willen und Gewissen, um Ihnen die Untersützung zu bieten, die Sie brauchen.
      </p>
      <br />
      <label>
        <input
          type="checkbox"
          checked={isAccepted}
          onChange={(e) => setIsAccepted(e.target.checked)}
          style={{ marginRight: 8 }}
        />
        Ich akzeptiere die <a href='/agb' style={{ color: '#B9A394', textDecoration: 'underline' }}>Nutzungsbedingungen von LEXDEX</a>
      </label>
      <br />
      <br />
    </div >
  );
}

export default TermsPage;